export const HIDE_UPDATE_BUTTON_SECTIONS = ['authentication', 'photo', 'manage_delegates'];
